import { render, staticRenderFns } from "./custom2.vue?vue&type=template&id=da37a7f2&scoped=true&"
import script from "./custom2.vue?vue&type=script&lang=js&"
export * from "./custom2.vue?vue&type=script&lang=js&"
import style0 from "./custom2.vue?vue&type=style&index=0&id=da37a7f2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da37a7f2",
  null
  
)

export default component.exports